import { render, staticRenderFns } from "./course_data_type_edit.vue?vue&type=template&id=2079d5b9&scoped=true"
import script from "./course_data_type_edit.vue?vue&type=script&lang=js"
export * from "./course_data_type_edit.vue?vue&type=script&lang=js"
import style0 from "./course_data_type_edit.vue?vue&type=style&index=0&id=2079d5b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079d5b9",
  null
  
)

export default component.exports